module.exports = __webpack_public_path__ + "img/kv1_sp.7f2a57bd.jpg";